import TopupType, { ITopupAction, TopupState } from "./topup.type";

const initialState: TopupState = {
    isLoading: false,
    error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: ITopupAction) => {
    switch (action.type) {

        case TopupType.CREATE_TRANSACTION_CODE.LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case TopupType.CREATE_TRANSACTION_CODE.SUCCESS:
            return {
                ...state,
                isLoading: false,
            };
        case TopupType.CREATE_TRANSACTION_CODE.ERROR:
            return {
                ...state,
                isLoading: false,
            };

        default:
            return state;
    }
};
